import * as React from 'react';
import * as _ from 'lodash';

import { IFacetResult, ITerm } from '../../state-helpers/facets';
import { FacetTerm } from './facet-term';
import { MultiselectDropdownFacetTerm } from './multiselect-dropdown-facet-term';

interface IProps {
    //Text shown on the dropdown
    summaryText: string;
    facet: IFacetResult;

    //Renders the terms on the facets as regular checkbox term facets.
    checkboxFacets: IFacetResult[];
    //Renders a collection of terms as a dropdown list of clickable facets
    dropdownTerms: ITerm[];
    dropdownVisible: boolean;

    // Callbacks
    onToggleMenu: () => void
    onToggleTerm: (term: ITerm) => void;
    onSelectAllFacetTerms: (facet: IFacetResult) => void;
    onClearAllFacetTerms: (facet: IFacetResult) => void;
}

interface IState {

}

//Displays a list of checkbox terms followed by a dropdown list of checkbox terms
export class MultiselectDropdownFacetSection extends React.Component<IProps, IState> {

    render() {
        const {
            summaryText,
            checkboxFacets,
            dropdownTerms,
            dropdownVisible,
            facet,
        } = this.props;

        if (dropdownTerms.length === 0) {
            return null;
        }

        const activeClass = dropdownVisible ? ' active' : '';
        const dropDownIcon = '&#x33;';
        const divId = 'search-facet-' + (facet.fieldName && facet.fieldName.replace(/\s+/g, '-')).toLowerCase();

        return (
            <div className="search-facet-item" id={divId}>

                <div className="search-facet-item-header">
                    <h5>{facet.name}</h5>
                </div>

                {/*Render checkbox facets as term facets*/}
                <div className="search-facet-item-list">
                    {checkboxFacets.map(this.renderFacetTerm)}
                </div>

                {/*Render dropdown facets as multiselect dropdown*/} 
                <li ref="multiSelect" onClick={this.onDropDownClick}>
                    <div className="multiSelect">

                        <div onClick={this.props.onToggleMenu} className={'summary' + activeClass}>
                            <span>{summaryText}</span>
                            <svg><use xlinkHref="#arrow-down"></use></svg>
                        </div>

                        <div className={'dropdown' + activeClass}>
                            <div className="controls">
                                <a onClick={() => this.props.onSelectAllFacetTerms(facet)} className="button-shop-dropdown">Select All</a>
                                <a onClick={() => this.props.onClearAllFacetTerms(facet)} className="button-shop-dropdown">Clear All</a>
                            </div>
                            <ul>
                                {facet.terms.map(this.renderDropdownTerm)}
                            </ul>
                        </div>
                    </div>
                </li>
            </div>
        );
    }

    renderFacetTerm = (facet: IFacetResult, index: number) => {
        return (
            <FacetTerm
                key={facet.terms[0].id}
                term={facet.terms[0]}
                onTermClick={() => this.props.onToggleTerm(facet.terms[0])} />
        )
    }

    renderDropdownTerm = (term: ITerm, index: number) => {
        return (
            <MultiselectDropdownFacetTerm
                key={term.id}
                term={term}
                onTermClick={() => this.props.onToggleTerm(term)} />
        )
    }

    // These could all be cleaned up a bit
    onDropDownClick = (ev) => {
        ev.nativeEvent.stopImmediatePropagation();
    }
}